import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../@core/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { CropYear } from '../models/cropYear';

@Injectable({
  providedIn: 'root'
})
export class CropYearService {

  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getCropYears(includeInactive: boolean = false): Observable<CropYear[]> {

    const queryParameters = new HttpParams().append('includeInactive', includeInactive.toString());

    return this.httpClient.get<CropYear[]>(`${this.basePath}/api/cropyears`, { params: queryParameters });
  }

  public putCropYear(cropYear: CropYear): Observable<CropYear[]> {
    return this.httpClient.put<CropYear[]>(`${this.basePath}/api/cropYears/${cropYear.id}`, cropYear);
  }

  public getCropYear(id: number): Observable<CropYear> {
    return this.httpClient.get<CropYear>(`${this.basePath}/api/CropYears/${id}`);
  }

  public getCurrentCropYear(cropId: number = 0): Observable<CropYear> {
    return this.httpClient.get<CropYear>(`${this.basePath}/api/CropYears/current/${cropId}`);
  }

  public deleteCropYear(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/CropYears/${id}`);
  }

  public postCropYear(cropYear: CropYear): Observable<CropYear[]> {
    return this.httpClient.post<CropYear[]>(`${this.basePath}/api/cropYears`, cropYear);
  }
}
